import React from 'react';
import { ChevronRight, Mail, Phone, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export const Footer = () => {
  const {
    t
  } = useLanguage();
  return <>
      <section className="py-8 md:py-16 bg-gradient-to-r from-blue-900 to-blue-800 text-white" data-id="element-47">
        <div className="container mx-auto px-3 md:px-8 text-center" data-id="element-48">
          <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6" data-id="element-49">
            {t('footer.finalCta')}
          </h2>
          <p className="text-base md:text-xl mb-6 md:mb-10 max-w-2xl mx-auto" data-id="element-50">
            {t('footer.finalDescription')}
          </p>
          <a href="https://knovastore.com/cart/47931982774491:1" className="inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white font-bold py-3 md:py-4 px-6 md:px-10 rounded-lg text-base md:text-xl transition duration-300 shadow-lg" data-id="element-51">
            {t('footer.finalButton')}
            <ChevronRight className="ml-2" size={24} data-id="element-52" />
          </a>
        </div>
      </section>
      <footer className="bg-navy-900 text-white py-8 md:py-12" data-id="element-53">
        <div className="container mx-auto px-3 md:px-8" data-id="element-54">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8 mb-6 md:mb-8" data-id="element-55">
            <div data-id="element-56">
              <div className="flex items-center space-x-3 mb-3 md:mb-4" data-id="element-57">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uyvRgaW7h8n3tpCXxGriZo/Generated_Image_November_14%2C_2025_-_4_12PM.png" alt="BranRock Logo" className="w-10 h-10 md:w-12 md:h-12" data-id="element-58" />
                <h3 className="text-xl md:text-2xl font-bold" data-id="element-59">BRANROCK</h3>
              </div>
              <p className="text-sm md:text-base text-gray-400 mb-3 md:mb-4" data-id="element-60">
                {t('footer.description')}
              </p>
              <div className="flex space-x-4" data-id="element-61">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-62">
                  <Facebook size={20} data-id="element-63" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-64">
                  <Instagram size={20} data-id="element-65" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-66">
                  <Twitter size={20} data-id="element-67" />
                </a>
              </div>
            </div>
            <div data-id="element-68">
              <h4 className="text-base md:text-lg font-bold mb-3 md:mb-4" data-id="element-69">
                {t('footer.quickLinks')}
              </h4>
              <ul className="space-y-2" data-id="element-70">
                <li data-id="element-71">
                  <a href="#beneficios" className="text-sm md:text-base text-gray-400 hover:text-white transition" data-id="element-72">
                    {t('header.benefits')}
                  </a>
                </li>
                <li data-id="element-73">
                  <a href="#testimonios" className="text-sm md:text-base text-gray-400 hover:text-white transition" data-id="element-74">
                    {t('header.testimonials')}
                  </a>
                </li>
                <li data-id="element-75">
                  <a href="#precios" className="text-sm md:text-base text-gray-400 hover:text-white transition" data-id="element-76">
                    {t('header.pricing')}
                  </a>
                </li>
                <li data-id="element-77">
                  <a href="#faq" className="text-sm md:text-base text-gray-400 hover:text-white transition" data-id="element-78">
                    {t('header.faq')}
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-79">
              <h4 className="text-base md:text-lg font-bold mb-3 md:mb-4" data-id="element-80">
                {t('footer.information')}
              </h4>
              <ul className="space-y-2" data-id="element-81">
                <li data-id="element-82">
                  <a href="#" className="text-sm md:text-base text-gray-400 hover:text-white transition" data-id="element-83">
                    {t('footer.privacyPolicy')}
                  </a>
                </li>
                <li data-id="element-84">
                  <a href="#" className="text-sm md:text-base text-gray-400 hover:text-white transition" data-id="element-85">
                    {t('footer.termsConditions')}
                  </a>
                </li>
                <li data-id="element-86">
                  <a href="#" className="text-sm md:text-base text-gray-400 hover:text-white transition" data-id="element-87">
                    {t('footer.returnPolicy')}
                  </a>
                </li>
                <li data-id="element-88">
                  <a href="#" className="text-sm md:text-base text-gray-400 hover:text-white transition" data-id="element-89">
                    {t('footer.shipping')}
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-90">
              <h4 className="text-base md:text-lg font-bold mb-3 md:mb-4" data-id="element-91">
                {t('footer.contact')}
              </h4>
              <ul className="space-y-3" data-id="element-92">
                <li className="flex items-start" data-id="element-93">
                  <Mail className="mr-2 md:mr-3 mt-1 flex-shrink-0" size={16} data-id="element-94" />
                  <span className="text-sm md:text-base text-gray-400" data-id="element-95">
                    support@branrock.com
                  </span>
                </li>
                <li className="flex items-start" data-id="element-96">
                  <Phone className="mr-2 md:mr-3 mt-1 flex-shrink-0" size={16} data-id="element-97" />
                  <span className="text-sm md:text-base text-gray-400" data-id="element-98">
                    +1 (555) 123-4567
                  </span>
                </li>
                <li className="flex items-start" data-id="element-99">
                  <MapPin className="mr-2 md:mr-3 mt-1 flex-shrink-0" size={16} data-id="element-100" />
                  <span className="text-sm md:text-base text-gray-400" data-id="element-101">
                    United States
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-700 pt-6 md:pt-8 text-center" data-id="element-102">
            <p className="text-sm md:text-base text-gray-400" data-id="element-103">
              {t('footer.copyright')}
            </p>
          </div>
        </div>
      </footer>
    </>;
};